/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";
import { getSubscribedUsersList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import { useParams } from "react-router-dom";
import Header from "../../Header/Header";
import "./SubscribedUsers.scss";

const SubscribedUsers = ({ getSubscribedUsersList, getStatisticsSuccess, monthlyUsers, annualUsers }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
    email: ""
  });
  const { type } = useParams(); // Get 'monthly' or 'annual' from URL

  // Determine the subscription type and labels
  const subscriptionType = type === 'monthly' ? 'monthly' : 'yearly'; // Use 'yearly' instead of 'annual'
  const filterLabel = subscriptionType === 'monthly' ? 'MONTHLY SUBSCRIPTION' : 'ANNUAL SUBSCRIPTION';
  const stateKey = subscriptionType === 'monthly' ? 'monthlyUsers' : 'annualUsers';
  const subscribedUsers = subscriptionType === 'monthly' ? monthlyUsers : annualUsers;

  // Helper function to create API payload
  const createApiPayload = (page = 1, additionalFilters = {}) => ({
    type: subscriptionType,
    name: additionalFilters.hasOwnProperty('fullName') ? additionalFilters.fullName || "" : filters.name || "",
    email: additionalFilters.hasOwnProperty('email') ? additionalFilters.email || "" : filters.email || "",
    registeredFrom: "",
    registeredTo: "",
    propertiesFrom: null,
    propertiesTo: null,
    walletsFrom: null,
    walletsTo: null,
    bankAccountsFrom: null,
    bankAccountsTo: null,
    page,
    limit: 20,
    onSuccess: () => setIsLoading(false),
    onError: () => setIsLoading(false)
  });

  // Handle filter changes from DataTable
  const handleFilterChange = (columnFilters) => {
    const newFilters = {
      name: columnFilters.fullName || "",
      email: columnFilters.email || ""
    };
    
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page when filtering
    setIsLoading(true);
    
    // Clear previous data and fetch with new filters
    getStatisticsSuccess({ type: stateKey, loading: true, docs: [], hasNextPage: false });
    getSubscribedUsersList(createApiPayload(1, columnFilters));
  };

  useEffect(() => {
    // Set loading state and fetch subscribed users
    getStatisticsSuccess({ type: stateKey, loading: true });
    setIsLoading(true);
    
    getSubscribedUsersList(createApiPayload(1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionType, stateKey]); // Re-fetch when subscription type changes

  const handleLoadMore = () => {
    if (subscribedUsers?.hasNextPage && !isLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsLoading(true);
      
      getSubscribedUsersList(createApiPayload(nextPage));
    }
  };

  const handleBackToDashboard = () => {
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div 
              className="close-icon" 
              onClick={handleBackToDashboard}
              title="Back to Dashboard"
            />
            <div className="inner-title">SUBSCRIBED USERS</div>
          </div>
          <div className="right-part">
            <div className="filter-label">
              <span className="filter-text">FILTERED BY:</span>
              <span className="filter-value">{filterLabel}</span>
            </div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={subscribedUsers || { docs: [] }}
            preset="subscribedUsers"
            isLoading={subscribedUsers?.loading || isLoading}
            onLoadMore={handleLoadMore}
            fetchData={(payload) => {
              // Update current page and loading state
              setCurrentPage(payload.page);
              setIsLoading(true);
              
              // Create the API payload with proper filter handling
              const apiPayload = createApiPayload(payload.page, payload.filters || {});
              
              getSubscribedUsersList({
                ...apiPayload,
                onSuccess: () => setIsLoading(false),
                onError: () => setIsLoading(false)
              });
            }}
            onFilterChange={handleFilterChange}
            hasMore={subscribedUsers?.hasNextPage}
            emptyStateText={`No ${subscriptionType} subscribers found`}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  monthlyUsers: state.dashboard.monthlyUsers,
  annualUsers: state.dashboard.annualUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribedUsersList: (payload) => dispatch(getSubscribedUsersList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribedUsers);
